
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';

import FAQ from './FAQ';
import UsePageTracking from '../components/usePageTracking';


function Puneairporttomumbaitaxi() {



    const cardData =
    {
        keyword: 'Pune Airport to Mumbai Taxi ',
        heading: 'Morya Cabs: Pune Airport to Mumbai Taxi ',
        headingDescription: 'Morya Cabs offers reliable and comfortable taxi services from Pune Airport to Mumbai, ensuring a smooth and hassle-free ride. Whether you are traveling for business, leisure, or a quick visit, our well-maintained fleet of vehicles and professional drivers ensure that you enjoy a stress-free journey. The distance between Pune Airport and Mumbai is approximately 150 km, and the journey typically takes around 3 to 4 hours by road, depending on traffic conditions. Choose Morya Cabs for a comfortable and efficient taxi service that meets your travel needs.',

        top: 'Top Places to Visit in Mumbai with Morya Cabs',

"topPlaces": [
    {
        "title": "Gateway of India",
        "location": "Mumbai, Maharashtra",
        "description": "The Gateway of India is an iconic monument and one of Mumbai’s most famous landmarks. Built in honor of King George V’s visit in 1911, it stands at the waterfront, offering spectacular views of the Arabian Sea. It is also a popular starting point for trips to Elephanta Island."
    },
    {
        "title": "Marine Drive",
        "location": "Mumbai, Maharashtra",
        "description": "Known as the 'Queen's Necklace' due to its sparkling streetlights at night, Marine Drive is a beautiful promenade along the coast. It offers a peaceful place for a walk or just to enjoy the sea breeze while overlooking the stunning skyline of Mumbai."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CST)",
        "location": "Mumbai, Maharashtra",
        "description": "A UNESCO World Heritage Site, CST is one of the most magnificent railway stations in India. Built in Victorian Gothic style, it serves as an important transport hub and is known for its impressive architecture."
    },
    {
        "title": "Elephanta Caves",
        "location": "Elephanta Island, Maharashtra",
        "description": "Located on Elephanta Island, these caves are a UNESCO World Heritage Site and are known for their ancient rock-cut temples dedicated to Lord Shiva. The caves are rich in history and art, making it a must-visit for history enthusiasts."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "location": "Mumbai, Maharashtra",
        "description": "The Bandra-Worli Sea Link is a remarkable piece of engineering that connects the suburbs of Bandra and Worli. Driving across this bridge offers a breathtaking view of the Mumbai coastline, especially during sunset."
    },
    {
        "title": "Chor Bazaar",
        "location": "Mumbai, Maharashtra",
        "description": "Known as the 'Thieves Market,' Chor Bazaar is one of Mumbai’s most famous markets for antiques and vintage items. It’s a great place for bargain hunters looking to take home a unique piece of history."
    },
    {
        "title": "Juhu Beach",
        "location": "Mumbai, Maharashtra",
        "description": "Juhu Beach is a popular destination for locals and tourists alike. It offers a great view of the Arabian Sea and is an excellent place to relax, enjoy street food, and watch beautiful sunsets."
    },
    {
        "title": "Siddhivinayak Temple",
        "location": "Mumbai, Maharashtra",
        "description": "Siddhivinayak Temple is one of the most revered Ganesh temples in India. The temple attracts thousands of devotees every day who come to seek the blessings of Lord Ganesha. Its peaceful ambiance and spiritual atmosphere make it an important site to visit."
    },
    {
        "title": "Haji Ali Dargah",
        "location": "Mumbai, Maharashtra",
        "description": "Haji Ali Dargah is an iconic mosque and tomb located in the middle of the Arabian Sea. It is one of the most famous landmarks in Mumbai, attracting devotees and tourists from all over the world."
    },
    {
        "title": "Colaba Causeway",
        "location": "Mumbai, Maharashtra",
        "description": "Colaba Causeway is one of the busiest streets in Mumbai and is known for its vibrant shopping scene, offering everything from clothing and jewelry to antique pieces and handicrafts. It's a great place to explore local markets and find unique souvenirs."
    }
],


"services": [
    {
        "name": "Pune Airport to Mumbai Taxi",
        "description": "Traveling from Pune Airport to Mumbai? Morya Cab offers the best taxi services to ensure a safe and comfortable journey. Whether you’re traveling alone or with a group, our fleet of well-maintained cars guarantees a smooth ride. Our drivers are experienced and professional, ensuring that your travel experience is stress-free and efficient. We are committed to providing you with the highest quality service, so you can sit back, relax, and enjoy the ride."
    },
    {
        "name": "Pune Airport to Mumbai Cab Service",
        "description": "When you need a reliable cab service from Pune Airport to Mumbai, look no further than Morya Cab. We provide a seamless travel experience with timely pickups and drop-offs at competitive prices. Whether you're heading for business meetings, a vacation, or just need a ride to Mumbai, our cab service ensures comfort and safety. Book your ride with us and experience why we are the preferred taxi service provider for both locals and tourists."
    },
    {
        "name": "Pune Airport to Mumbai Taxi Fare",
        "description": "Our taxi fares for journeys from Pune Airport to Mumbai are affordable and transparent. Morya Cab believes in no hidden charges, and our pricing is competitive to ensure that you get the best value for your money. Whether you need a quick ride or a longer journey, we offer affordable options to meet your needs. Get in touch with us for a quote today, and we guarantee you a fair and budget-friendly fare."
    },
    {
        "name": "Pune Airport to Mumbai One Way Taxi",
        "description": "For travelers who need a one-way taxi from Pune Airport to Mumbai, Morya Cab offers convenient options. We understand that time is crucial, and our one-way taxi service ensures that you can reach your destination quickly and comfortably. Choose from a variety of vehicles based on your preferences, including our popular sedan, Ertiga, or Innova, for an enhanced travel experience."
    },
    {
        "name": "Pune Airport to Mumbai Innova",
        "description": "For families, groups, or those seeking extra comfort, our Innova taxis from Pune Airport to Mumbai are a perfect choice. The spacious and luxurious Innova provides plenty of room for passengers and luggage. With Morya Cab, you can enjoy a premium travel experience at a reasonable price. Our Innova cabs are fully equipped with air conditioning and other comfort features to ensure you travel in style and comfort."
    },
    {
        "name": "Pune Airport to Mumbai Ertiga",
        "description": "The Ertiga is another excellent vehicle option for your journey from Pune Airport to Mumbai. Ideal for small families or groups, the Ertiga offers ample space and a comfortable ride. Whether you're heading to a business meeting or on a family trip, Morya Cab’s Ertiga taxis provide a comfortable and affordable solution. Book your ride today and enjoy the convenience of a spacious vehicle with a professional driver."
    },
    {
        "name": "Pune Airport to Mumbai Sedan",
        "description": "If you prefer a more compact yet comfortable ride, the sedan taxi from Pune Airport to Mumbai is an excellent choice. Morya Cab offers well-maintained sedans with professional drivers who will ensure you reach your destination quickly and safely. Our sedans are perfect for solo travelers, couples, or small groups looking for a simple yet comfortable taxi service."
    },
    {
        "name": "Pune Airport to Mumbai Taxi Booking",
        "description": "Booking your taxi from Pune Airport to Mumbai has never been easier. With Morya Cab’s online booking system, you can reserve your ride in just a few clicks. You can also book by phone or via our mobile app. We ensure that your taxi is ready on time, so you can travel with ease and confidence. Whether you're booking for a one-time trip or frequent travels, we make the process simple and efficient."
    },
    {
        "name": "Taxi Service from Pune Airport to Mumbai",
        "description": "Morya Cab provides a reliable and efficient taxi service from Pune Airport to Mumbai. Our experienced drivers are familiar with the best routes and traffic patterns, ensuring a smooth and timely ride. Whether you're heading to a business conference, a hotel, or any other destination in Mumbai, our taxi service is here to meet your needs. We also provide customer support for any questions or special requests you may have during your journey."
    },
    {
        "name": "Pune to Mumbai Airport Taxi",
        "description": "If you need a taxi from Pune to Mumbai Airport, Morya Cab offers a professional and convenient solution. Our experienced drivers will pick you up from your location in Pune and take you directly to Mumbai Airport, ensuring you arrive on time for your flight. We understand the importance of punctuality, especially when traveling to the airport, so you can trust us for timely service and peace of mind."
    },
    {
        "name": "Mumbai Airport Taxi Booking",
        "description": "Book your Mumbai Airport taxi easily through Morya Cab’s online portal or app. Whether you're flying in or out of Mumbai, we provide quick and affordable airport transfers. Our drivers are well-versed with the airport's procedures and will meet you at the designated pick-up points to ensure a smooth transfer."
    },
    {
        "name": "Pune Airport to Mumbai by Cab",
        "description": "If you prefer to travel by cab from Pune Airport to Mumbai, Morya Cab offers a variety of options to suit your preferences. Our cars are comfortable, and our drivers are skilled at ensuring a safe, efficient journey. Whether it's a short trip or a long drive, our cab service guarantees that you’ll enjoy the ride with the utmost comfort."
    },
    {
        "name": "Pune to Mumbai Drop Taxi",
        "description": "Morya Cab offers drop taxi services from Pune to Mumbai for those looking for a one-way transfer. We’ll ensure a smooth journey with well-maintained vehicles and reliable service. Whether it’s a business trip or personal travel, our drop taxi service offers flexibility and convenience."
    },
    {
        "name": "Mumbai to Pune Airport Taxi Service",
        "description": "Morya Cab also provides a seamless taxi service for journeys from Mumbai to Pune Airport. If you’re flying out of Pune, our taxis will pick you up from your location in Mumbai and drop you off at the airport on time. Our drivers are experienced with airport protocols and will ensure you get to the terminal without any delays."
    },
    {
        "name": "Affordable Taxi Pune to Mumbai",
        "description": "At Morya Cab, we believe in offering affordable taxi services without compromising on quality. Whether you're booking a ride for a quick business trip or a leisure journey, we have options to suit every budget. You can trust us to provide an affordable and comfortable ride from Pune to Mumbai with no hidden charges."
    }
],


tableData: [
    ["Pune Airport to Mumbai Taxi", "-Pune Airport to Mumbai Cab Service"],
    ["Pune Airport to Mumbai Taxi Fare", "-Pune Airport to Mumbai One Way Taxi"],
    ["Pune Airport to Mumbai Innova", "-Pune Airport to Mumbai Ertiga"],
    ["Pune Airport to Mumbai Sedan", "-Pune Airport to Mumbai Taxi Booking"],
    ["Taxi Service from Pune Airport to Mumbai", "-Pune to Mumbai Airport Taxi"],
    ["Mumbai Airport Taxi Booking", "-Pune Airport to Mumbai by Cab"],
    ["Pune to Mumbai Drop Taxi", "-Mumbai to Pune Airport Taxi Service"],
    ["Affordable Taxi Pune to Mumbai", ""]
],

whychoose: [
    {
        "WhyChooseheading": "Reliable and On-Time Service",
        "WhyChoosedescription": "Morya Cab guarantees punctual pickups and timely drop-offs for your trip from Pune Airport to Mumbai. Whether it's a flight arrival or a quick transfer, our drivers ensure your journey is smooth and timely, making your travel stress-free."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Vehicles",
        "WhyChoosedescription": "Travel in comfort with our well-maintained vehicles. Our fleet includes sedans, SUVs, and premium cars, all designed for long-distance travel, equipped with ample legroom, air conditioning, and comfortable seating to make your journey from Pune Airport to Mumbai a pleasant one."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Our drivers are well-trained and experienced, ensuring safe, efficient, and comfortable travel. They know the best routes and ensure smooth navigation, so you don’t have to worry about anything during your trip."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "We offer competitive pricing for your Pune Airport to Mumbai taxi service, with no hidden charges. Our transparent pricing structure guarantees that you’ll know the total cost upfront, providing you with the best value for your money."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Journey",
        "WhyChoosedescription": "Your safety is our top priority. All vehicles are regularly inspected and equipped with modern safety features like airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure your journey is as safe as possible."
    },
    {
        "WhyChooseheading": "24/7 Availability",
        "WhyChoosedescription": "We offer round-the-clock service for your convenience. Whether you need a taxi at the crack of dawn or after a late-night arrival, Morya Cab is always available to assist you with your travel needs."
    },
    {
        "WhyChooseheading": "Hassle-Free Booking Process",
        "WhyChoosedescription": "Booking a taxi from Pune Airport to Mumbai is quick and easy with Morya Cab. You can book online through our website or mobile app, or you can contact our customer service team for any assistance."
    },
    {
        "WhyChooseheading": "Customized Travel Packages",
        "WhyChoosedescription": "If you have special requirements, like additional stops or a particular route, we offer customized travel packages tailored to your preferences. Let us know your needs, and we’ll adjust accordingly."
    }
]















    }

    const faqData = [
        {
          question: "How can I book a Pune Airport to Mumbai taxi with Morya Cab?",
          answer: "You can book a taxi easily through our website or mobile app. Alternatively, you can contact our customer service team for assistance with booking."
        },
        {
          question: "Are the drivers experienced for long-distance travel?",
          answer: "Yes, our drivers are experienced in handling long-distance routes like Pune Airport to Mumbai. They are skilled in providing a smooth, safe, and timely journey."
        },
        {
          question: "What types of vehicles are available for Pune Airport to Mumbai travel?",
          answer: "We offer a variety of well-maintained vehicles, including sedans, SUVs, and premium cars, ensuring comfort and convenience throughout your journey."
        },
        {
          question: "How do I pay for my Pune Airport to Mumbai taxi rental?",
          answer: "We accept multiple payment methods, including cash, credit/debit cards, and online payments via our app, making payment easy and flexible."
        },
        {
          question: "Can I book a round trip from Pune Airport to Mumbai?",
          answer: "Yes, you can book a round-trip taxi. Simply provide your return details when making your booking, and we’ll arrange everything for your convenience."
        },
        {
          question: "Are there any extra charges for waiting or detours?",
          answer: "If there are additional charges for waiting time or detours, we’ll communicate them to you upfront during the booking process, ensuring complete transparency."
        },
        {
          question: "Can I hire a taxi for sightseeing in Mumbai after my airport transfer?",
          answer: "Yes, we can arrange a sightseeing tour in Mumbai after your airport transfer. Visit iconic spots like the Gateway of India, Marine Drive, and more with a trusted driver."
        },
        {
          question: "What is the luggage allowance for a Pune Airport to Mumbai taxi?",
          answer: "Our vehicles can accommodate standard luggage. If you have more luggage or specific requirements, please inform us during the booking, and we will make the necessary arrangements."
        },
        {
          question: "Is Morya Cab available for corporate travel from Pune Airport to Mumbai?",
          answer: "Yes, we offer corporate travel services. Whether it’s for meetings or business events, we can provide a customized travel package tailored to your company's needs."
        },
        {
          question: "Why should I choose Morya Cab for Pune Airport to Mumbai travel?",
          answer: "Morya Cab is known for its reliable, safe, and comfortable service, professional drivers, well-maintained vehicles, and transparent pricing. We guarantee a smooth, timely, and stress-free journey for your airport transfer."
        }
      ];
      
      const testimonialData = [
        {
          id: 1,
          name: 'Mr. Rahul Shinde',
          role: 'Business Traveler',
          review: 'I booked a taxi from Pune Airport to Mumbai, and the experience was excellent. The driver was punctual, and the ride was comfortable. Will definitely use Morya Cab again!',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        },
        {
          id: 2,
          name: 'Mrs. Priya Joshi',
          role: 'Family Traveler',
          review: 'Our flight landed late at Pune Airport, and we were relieved to find that Morya Cab was ready for our transfer to Mumbai. The service was impeccable, and the driver was courteous.',
          rating: 5,
          quoteIcon: '/img/icon/testi-quote.svg',
        }
      ];
      
      
      
      
      
      







    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9371304510",
            "+91 8379975860",



        ],
        email: "booking@moryacab.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Shirdi Taxi",
            link: "/Pune-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Bhimashankar Taxi",
            link: "/Pune-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai Taxi",
            link: "/Pune-to-Mumbai-Taxi"
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Lonavala Taxi",
            link: "/Pune-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Mahabaleshwar Taxi",
            link: "/Pune-to-Mahabaleshwar-Taxi"
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Aurangabad Taxi",
            link: "/Pune-to-Aurangabad-Taxi"
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Nashik-Trimbakeshwar Taxi",
            link: "/Pune-to-Nashik-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Car Rental Services",
            link: "/Pune-Car-Rental-Services"
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Ashtavinayak Taxi",
            link: "/Pune-to-Ashtavinayak-Taxi"
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Pune to Goa Taxi",
            link: "/Pune-to-Goa-Taxi"
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Solapur Taxi",
            link: "/Pune-to-Solapur-Taxi"
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Hyderabad Cab",
            link: "/Pune-to-Hyderabad-Cab"
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Pune to Kolhapur Taxi",
            link: "/Pune-to-Kolhapur-Taxi"
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Pune to Bangalore Taxi",
            link: "/Pune-to-Bangalore-Taxi"
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Pune to Indore Taxi",
            link: "/Pune-to-Indore-Taxi"
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Mumbai to Shirdi Taxi",
            link: "/Mumbai-to-Shirdi-Taxi"
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Borivali to Pune Taxi Service",
            link: "/Borivali-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Vasai to Pune Taxi Service",
            link: "/Vasai-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Dombivli to Pune Taxi Services",
            link: "/Dombivli-to-Pune-Taxi-Services"
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Dadar to Shirdi Taxi Service",
            link: "/Dadar-to-Shirdi-Taxi-Service"
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Mumbai to Trimbakeshwar Taxi",
            link: "/Mumbai-to-Trimbakeshwar-Taxi"
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Mumbai to Bhimashankar Taxi",
            link: "/Mumbai-to-Bhimashankar-Taxi"
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Mumbai Central to Pune Taxi",
            link: "/Mumbai-Central-to-Pune-Taxi"
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Thane to Pune Taxi Service",
            link: "/Thane-to-Pune-Taxi-Service"
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Mumbai to Nashik Taxi",
            link: "/Mumbai-to-Nashik-Taxi"
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Mumbai to Lonavala Taxi",
            link: "/Mumbai-to-Lonavala-Taxi"
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Mumbai Airport to Pune Taxi",
            link: "/Mumbai-Airport-to-Pune-Taxi"
        }
    ];


    const images = [
        { src: "/images/our-fleet/3.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/4.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/5.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/7.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/8.jpg", alt: "Image 1" },
        { src: "/images/our-fleet/10.jpg", alt: "Image 1" },
       
    ];

    const jsonLD = {
        "@context": "https://schema.org",
        "@type": "LocalBusiness",
        "name": "Morya Cab Services",
        "description": "Book your Pune Airport to Mumbai taxi with Morya Cab. Affordable, reliable one-way taxis, drop-off services, and more! Call +91 9371304510 for bookings!",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "Office No. 5, First Floor, Sunshine Complex, Near ABC Chowk, Pune",
          "addressLocality": "Pune",
          "addressRegion": "Maharashtra",
          "postalCode": "411014",
          "addressCountry": "IN"
        },
        "telephone": "+91-9371304510",
        "url": "https://moryacab.com/",
        "logo": "https://moryacab.com/img/logo.jpg",
        "image": [
          "https://moryacab.com/img/pune-airport-to-mumbai-taxi.jpg",
          "https://moryacab.com/img/pune-to-mumbai-cab-service.jpg"
        ],
        "priceRange": "₹2000 - ₹3500",
        "offers": {
          "@type": "Offer",
          "url": "https://moryacab.com/pune-airport-to-mumbai-taxi-service",
          "priceCurrency": "INR",
          "price": 3000,
          "priceValidUntil": "2025-12-31"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": 4.8,
          "reviewCount": 1550
        },
        "review": [
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Ravi Joshi"
            },
            "datePublished": "2024-06-10",
            "reviewBody": "The taxi ride from Pune Airport to Mumbai was smooth and comfortable. The driver was polite, and the car was in excellent condition. Highly recommended!"
          },
          {
            "@type": "Review",
            "author": {
              "@type": "Person",
              "name": "Neha Sharma"
            },
            "datePublished": "2024-09-03",
            "reviewBody": "Booking the taxi was easy and affordable. The ride was punctual, and the vehicle was well-maintained. Will definitely use this service again!"
          }
        ],
        "serviceArea": {
          "@type": "Place",
          "name": "Pune Airport to Mumbai Taxi Service",
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 18.5575,
            "longitude": 73.9268
          }
        },
        "availableChannel": {
          "@type": "ServiceChannel",
          "serviceUrl": "https://moryacab.com/pune-airport-to-mumbai-taxi-service"
        },
        "keywords": "pune airport to mumbai taxi, pune airport to mumbai cab service, pune airport to mumbai taxi fare, pune airport to mumbai one way taxi, taxi from pune airport to mumbai, pune to mumbai airport taxi, mumbai airport taxi booking, affordable taxi pune to mumbai"
      };




    return (
        <div>
            <UsePageTracking/>
 <Helmet>
        <title>Pune Airport to Mumbai Taxi | Call: +91 9371304510</title>
        <meta
          name="description"
          content="Book your Pune Airport to Mumbai taxi with Morya Cab. Affordable, reliable one-way taxis, drop-off services, and more! Call +91 9371304510."
        />
        <meta
          name="keywords"
          content="pune airport to mumbai taxi, pune airport to mumbai cab service, pune airport to mumbai taxi fare, pune airport to mumbai one way taxi, taxi from pune airport to mumbai, pune to mumbai airport taxi, mumbai airport taxi booking, affordable taxi pune to mumbai"
        />
        <meta property="og:title" content="Pune Airport to Mumbai Taxi | Morya Cab Services" />
        <meta
          property="og:description"
          content="Book your Pune Airport to Mumbai taxi with Morya Cab. Affordable, reliable one-way taxis, drop-off services, and more!"
        />
        <meta property="og:url" content="https://moryacab.com/pune-airport-to-mumbai-taxi-service" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://moryacab.com/img/pune-airport-to-mumbai-taxi.jpg" />
        <script type="application/ld+json">
          {JSON.stringify(jsonLD)}
        </script>
      </Helmet>


            <div className="breadcumb-wrapper" style={{ backgroundImage: 'url(/img/bg/breadcumb-bg.jpg)' }}>
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F8911B', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                // padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                               style={{
                                    cursor: 'pointer',
                                    // padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className=''>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Morya Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQ faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonialData={testimonialData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                                            {Images.map((e) => {
    return (
        <div className="box1" key={e.text}>
            <a
                href={e.link} // Use the separate link for each item
                className="d-flex justify-content-around align-items-center"
            >
                <div className="b1">
                    <img src={e.place} alt={e.text} />
                </div>
                <div className="b2">
                    <a href={e.link} className="px-3 colorr">{e.text}</a>
                </div>
            </a>
        </div>
    );
})}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #1CA8CB',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#0AB4A9' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+91 9371304510" className="d-block  text-white">+91 9371304510</a>
                                                <a href="tel:+91 8379975860" className="d-block  text-white">+91 8379975860</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@moryacab.com" className=" text-white d-block">
                                                    booking@moryacab.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#0AB4A9' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Morya Cab<br />
                                                    Gat no. 763 Jai Ganesh Niwas Flat no. 1 Lokhande Wasti Chimbali Pune, Maharashtra 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </section>

        </div>
    );
}

export default Puneairporttomumbaitaxi;